import { getConfig } from "../config";

/**
 * Analytics is an opt-in feature gated by a Key Vault secret.
 *
 * The secret `AnalyticsEnabled` (value "Y" to enable) flows into
 * `window.config.analyticsEnabled` via the same path as the Syncfusion key:
 * `config.aspx` (server env var `ANALYTICS_ENABLED`) when deployed somewhere that
 * executes .aspx, or the `__ANALYTICS_ENABLED__` token the pipeline injects into
 * index.html at build time (the real path on Azure Static Web Apps).
 *
 * Only the exact value "Y" (case-insensitive, trimmed) turns Analytics on. Any
 * other value — empty, "N", or the unreplaced `__ANALYTICS_ENABLED__` token in
 * local dev — keeps every Analytics entry point hidden. Read lazily via
 * getConfig() so it always reflects the live window.config and stays mockable in
 * tests.
 */
export const isAnalyticsEnabled = (): boolean =>
  (getConfig()?.analyticsEnabled ?? "").trim().toUpperCase() === "Y";
